<template>
  <div class='invoiceEntry-wraper'>
    <iframe :src="url" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Toast
  } from "vant";
  Vue.use(Toast);
  export default {
    name: "invoiceEntry",
    components: {},
    data() {
      return {
        url: "",
        companyID: this.$route.query.companyID
      };
    },
    created() {
      this.$http.get("/fc/small/program/crm/menurl?menuId=2001&companyId=" + this.companyID).then(res => {
        if (res.data.code == 200) {
          this.url = res.data.data;
        } else {
          Toast({
            type: "error",
            message: res.data.msg
          });
        }
      });
    },
    computed: {},
    methods: {},
    mounted() {}
  };
</script>

<style scoped>
  .invoiceEntry-wraper {
    width: 100%;
    height: 100%;
  }
</style>